import { NewsLetterSubscription } from "../models/newslettersubscription.model";
import { NewsletterView } from "../models/newsletterview.model";
import { responseHero } from "../utils/axiosInterceptor";

export const getNewsLetterViewers = (videoId: string): Promise<NewsletterView[]> => {
    return new Promise<NewsletterView[]>((resolve, reject) => {
        if(!videoId) return;
        
        responseHero.get(`${process.env.REACT_APP_API_URL}/viewers/${videoId}`).then((response) => {
            resolve(response.data as NewsletterView[]);
        })
        .catch(error => {
            console.error(error);
            reject(error);
        });
    });
};